import { PERMISSIONS } from '../../../Enums/permission.enum';
import { HomeFleetStage } from '../Types/home-fleet-stage.type';

export const HOME_FLEET_STAGE_ORDER: readonly HomeFleetStage[] = [
  'anomalies',
  'entra_admin_roles',
  'm365_licences',
];

export const HOME_FLEET_STAGE_PERMISSION: Record<HomeFleetStage, PERMISSIONS> = {
  anomalies: PERMISSIONS.ANOMALIES_REPORT,
  entra_admin_roles: PERMISSIONS.ENTRA_ADMIN_REPORT,
  m365_licences: PERMISSIONS.M365_LICENSE_REPORT,
};

export const HOME_FLEET_STAGE_ICON: Record<HomeFleetStage, string> = {
  anomalies: 'devices',
  entra_admin_roles: 'admin_panel_settings',
  m365_licences: 'badge',
};

export const HOME_OS_SHARE_LIMIT = 4;
